import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=31108b4e&scoped=true&"
import script from "./fankui.vue?vue&type=script&lang=js&"
export * from "./fankui.vue?vue&type=script&lang=js&"
import style0 from "./fankui.vue?vue&type=style&index=0&id=31108b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31108b4e",
  null
  
)

export default component.exports